import { GET_LOCATIONS } from './const';
import labels from '../i18n';

export default (lang) => ({
  type: GET_LOCATIONS,
  payload: [
    {
      label: labels[lang].locations.aarhus,
      value: '8000-8299',
    },
    {
      label: labels[lang].locations.cph,
      value: '1000-2999',
    },
    {
      label: labels[lang].locations.herning,
      value: '7400',
    },
    {
      label: labels[lang].locations.foulum,
      value: '8830',
    },
    {
      label: labels[lang].locations.roskilde,
      value: '4000',
    },
    {
      label: labels[lang].locations.jutland,
      value: '6000-9999',
    },
    {
      label: labels[lang].locations.zealand,
      value: '1000-5999',
    },
    {
      label: labels[lang].locations.outside,
      value: '0',
    },
  ],
});
